// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuecal__menu, .vuecal__cell-events-count {
    background-color: #9fa0a2;
}

.vuecal__title-bar {
    background-color: #4e73df;
}

.vuecal__cell--today, .vuecal__cell--current {
    background-color: #4e73df;
}

.vuecal:not(.vuecal--day-view) .vuecal__cell--selected {
    background-color: rgba(235, 255, 245, 0.4);
}

.vuecal__cell--selected:before {
    border-color: rgba(66, 185, 131, 0.5);
}

/*.vuecal__cell--has-events {
    background-color: #fffacd;
}*/

.vuecal--short-events .vuecal__event-title {
    background-color: #11a000;
    color: white;
}

.vuecal__event.dutyyellow .vuecal__event-title {
    background-color: #ffdd00;
    color: black;
}

.vuecal__event.dutyred .vuecal__event-title {
    background-color: #ff3300;
    color: black;
}`, "",{"version":3,"sources":["webpack://./ClientApp/components/calendar/calendar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;EAEE;;AAEF;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".vuecal__menu, .vuecal__cell-events-count {\r\n    background-color: #9fa0a2;\r\n}\r\n\r\n.vuecal__title-bar {\r\n    background-color: #4e73df;\r\n}\r\n\r\n.vuecal__cell--today, .vuecal__cell--current {\r\n    background-color: #4e73df;\r\n}\r\n\r\n.vuecal:not(.vuecal--day-view) .vuecal__cell--selected {\r\n    background-color: rgba(235, 255, 245, 0.4);\r\n}\r\n\r\n.vuecal__cell--selected:before {\r\n    border-color: rgba(66, 185, 131, 0.5);\r\n}\r\n\r\n/*.vuecal__cell--has-events {\r\n    background-color: #fffacd;\r\n}*/\r\n\r\n.vuecal--short-events .vuecal__event-title {\r\n    background-color: #11a000;\r\n    color: white;\r\n}\r\n\r\n.vuecal__event.dutyyellow .vuecal__event-title {\r\n    background-color: #ffdd00;\r\n    color: black;\r\n}\r\n\r\n.vuecal__event.dutyred .vuecal__event-title {\r\n    background-color: #ff3300;\r\n    color: black;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
